import type { VehicleShapeDefinition } from './vehicleShape';

/**
 * Timber crane vehicle
 * Features a crane arm for handling logs
 */
export const timberCraneShape: VehicleShapeDefinition = {
  vehicle: 'timber_crane',
  coordinateSystem: '2D',
  unit: 'normalized_percent',
  polygons: {
    // Front wheels
    front_wheel_left: [
      [15, 24],
      [35, 24],
      [35, 49],
      [15, 49],
    ],

    front_wheel_right: [
      [65, 24],
      [85, 24],
      [85, 49],
      [65, 49],
    ],

    // Rear wheels
    rear_wheel_left: [
      [15, 84],
      [35, 84],
      [35, 109],
      [15, 109],
    ],

    rear_wheel_right: [
      [65, 84],
      [85, 84],
      [85, 109],
      [65, 109],
    ],

    // Main body
    body: [
      [25, 44],
      [75, 44],
      [75, 89],
      [25, 89],
    ],

    // Crane base
    crane_base: [
      [35, 59],
      [65, 59],
      [65, 74],
      [35, 74],
    ],

    // Crane arm extending forward
    crane_arm: [
      [40, 14],
      [60, 14],
      [60, 59],
      [40, 59],
    ],

    // Crane grapple at the end
    crane_grapple: [
      [10, 20],
      [50, 0],
      [90, 20],
      [50, 14],
    ],
  },
  colorConfig: {
    body: { type: 'dynamic' }, // Uses vehicle color
    front_wheel_left: { type: 'fixed', color: '#000000' },
    front_wheel_right: { type: 'fixed', color: '#000000' },
    rear_wheel_left: { type: 'fixed', color: '#000000' },
    rear_wheel_right: { type: 'fixed', color: '#000000' },
    cabin: { type: 'fixed', color: '#000000' },
    crane_base: { type: 'fixed', color: '#000000' },
    crane_arm: { type: 'fixed', color: '#000000' },
    crane_grapple: { type: 'fixed', color: '#000000' },
  },
};
